import type { DialogProps as IDialogProps } from '@mui/material/Dialog';
import { Theme } from '@mui/material/styles';

declare module '@mui/material/Dialog' {
  interface DialogProps {
    align?: 'top' | 'bottom' | 'left' | 'right';
  }
}

export default function Dialog(theme: Theme) {
  return {
    MuiDialog: {
      styleOverrides: {
        root({ align }: IDialogProps) {
          if (!align) return {};

          return {
            '& .MuiDialog-container': {
              overflowY: 'auto',
              paddingTop: theme.spacing(16),
              paddingBottom: theme.spacing(8),
              ...(align === 'top' && { alignItems: 'flex-start' }),
              ...(align === 'bottom' && { alignItems: 'flex-end' }),
              ...(align === 'left' && {
                alignItems: 'center',
                justifyContent: 'flex-start',
              }),
              ...(align === 'right' && {
                alignItems: 'center',
                justifyContent: 'flex-end',
              }),
            },
            '& .MuiPaper-root': {
              maxHeight: 'none',
            },
          };
        },
        paper: {
          boxShadow: theme.customShadows.dialog,
          backgroundColor: theme.palette.background.default,
          border: `.5px solid ${theme.palette.divider}`,
          '&.MuiPaper-rounded': {
            borderRadius: theme.spacing(1),
          },
          '&.MuiDialog-paperFullScreen': {
            borderRadius: theme.spacing(0.5),
          },
          '&.MuiDialog-paper .MuiDialogActions-root': {
            padding: theme.spacing(3),
          },
          '@media (max-width: 600px)': {
            margin: theme.spacing(2),
          },
          '@media (max-width: 663.95px)': {
            '&.MuiDialog-paperWidthSm.MuiDialog-paperScrollBody': {
              maxWidth: '100%',
            },
          },
        },
        paperFullWidth: {
          width: '100%',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0, 3),
          overflowY: 'initial',
        },
        dividers: {
          borderTop: 0,
          borderBottomStyle: 'dashed',
          paddingBottom: theme.spacing(3),
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          '& > :not(:first-of-type)': {
            marginLeft: theme.spacing(1.5),
          },
        },
      },
    },
  };
}
